import '../plugins/fixedScrollBlockPlugin';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

export default function initFixedPanel() {

	gsap.registerPlugin(ScrollTrigger);
	gsap.registerPlugin(ScrollToPlugin);

	const stickyBlocks = document.querySelectorAll('.js-fixed-nav-panel');
	stickyBlocks.forEach((stickyBlock) => {

		if (stickyBlock && stickyBlock.classList.contains('nav-anchorlinks-section')) {
			document.documentElement.style.setProperty('--nav-anchorlinks-section-height', `${stickyBlock.offsetHeight}px`);
		}
	});

	
	jQuery('.js-fixed-nav-panel').stickyScrollBlock({
		setBoxHeight: true,
		activeClass: 'fixed-position',
		positionType: 'fixed',
		fixedOn: function(stickyBlock) {
			//if we have both nav-anchorlinks and page-toggle we need to stack them
			if (stickyBlock && stickyBlock[0].classList.contains('page-toggle-section')) {
				document.documentElement.style.setProperty('--toggle-section-height', `${stickyBlock[0].offsetHeight}px`);
			}
			if (stickyBlock && stickyBlock[0].classList.contains('nav-anchorlinks-section')) {
				document.documentElement.style.setProperty('--nav-anchorlinks-section-height', `${stickyBlock[0].offsetHeight}px`);
			}
			if (stickyBlock && stickyBlock[0].classList.contains('resource-filter-section')) {
				stickyBlock[0].classList.add("scrolled");
			}
		},
		fixedOff: function(stickyBlock) {
			//if we have both nav-anchorlinks and page-toggle we need to stack them
			if (stickyBlock && stickyBlock[0].classList.contains('page-toggle-section')) {
				document.documentElement.style.setProperty('--toggle-section-height', `0px`);
			}
			if (stickyBlock && stickyBlock[0].classList.contains('nav-anchorlinks-section')) {
				//document.documentElement.style.setProperty('--nav-anchorlinks-section-height', `0px`);
			}
			if (stickyBlock && stickyBlock[0].classList.contains('resource-filter-section')) {
				stickyBlock[0].classList.remove("scrolled");
			}
		},
		extraTop: () => {
			let totalHeight = 0;
			jQuery('0').each(() => {
				totalHeight += jQuery(this).outerHeight();
				// totalHeight += jQuery('header').outerHeight();
			});
			return totalHeight;
		},
	});
	

	/**
	 * Resource Article Fixed Left Rail
	 */

	document.querySelectorAll('.resource-holder').forEach((resourceArticle) => {
		if(! resourceArticle.querySelector('.js-fixed-resource-rail')) return false;		
		ScrollTrigger.create({
			trigger: '.js-fixed-resource-rail',
			// start: `top top+=${topMenu.offsetHeight + 50}`,
			start: () => {
				let leftColObj = resourceArticle.querySelector('.js-fixed-resource-rail');
				let topMenu = document.querySelector('header.header');
				return `top top+=${topMenu.offsetHeight + 50}`
			},
			// endTrigger: resourceArticle.querySelector('resource-main'),
			end: () => {
				let leftColObj = resourceArticle.querySelector('.js-fixed-resource-rail');
				let topMenu = document.querySelector('header.header');
				let contentObj = resourceArticle.querySelector('.resource-main');
				//old way...jumped and did not account for announcement bar
				console.log(`bottom top+=${leftColObj.offsetHeight + topMenu.offsetHeight + 150}`);
				return `+=${contentObj.offsetHeight + topMenu.offsetHeight - leftColObj.offsetHeight - 400}`;
			},
			fastScrollEnd: true,
			// markers: {startColor: "red", endColor: "blue", fontSize: "18px", fontWeight: "bold", indent: 20},
			pin: true,
			pinSpacing: false,
			invalidateOnRefresh: true,

		});
	});

}
